import CryptoJS from "crypto-js";
import { SECRET_KEY } from "./env";

export function encryptMessage(str, key = SECRET_KEY) {
  return CryptoJS.AES.encrypt(str, key).toString();
}

export function decryptMessage(str, key = SECRET_KEY) {
  console.log(SECRET_KEY);
  const bytes = CryptoJS.AES.decrypt(str, key);
  console.log(bytes.toString(CryptoJS.enc.Utf8));
  return bytes.toString(CryptoJS.enc.Utf8);
}
